module.exports = __webpack_public_path__ + "static/media/hotjar-01.92d88fb7.svg";